export const API_BASE = process.env.REACT_APP_API_URL || '/api/v1';

export async function apiFetch(endpoint, options = {}) {
  const res = await fetch(`${API_BASE}${endpoint}`, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  });
  if (!res.ok) {
    const error = await res.json().catch(() => ({}));
    throw new Error(error.detail || `HTTP ${res.status}`);
  }
  return res.json();
}

// The backend caps `limit` at 100 per page. Paginated list/search endpoints return
// { total, page, limit, results }; this walks every page so callers get the full set
// instead of silently working off just the first 10-100 records.
const MAX_PAGE_LIMIT = 100;
const MAX_PAGES = 25; // safety cap: 2,500 records

export async function fetchAllPages(endpoint, baseParams = {}) {
  let all = [];
  let page = 1;
  let total = Infinity;
  while (all.length < total && page <= MAX_PAGES) {
    const params = new URLSearchParams({ ...baseParams, page, limit: MAX_PAGE_LIMIT });
    const data = await apiFetch(`${endpoint}?${params}`);
    const results = data.results || [];
    all = all.concat(results);
    total = typeof data.total === 'number' ? data.total : all.length;
    if (results.length < MAX_PAGE_LIMIT) break;
    page += 1;
  }
  return { results: all, total };
}
